<template>
  <div class="notice">
    <h2>Pollogo Major Version Upgrade Announcement</h2>
    <div>
      <p>Dear Pollogo Users,</p>
      <p>Thank you for your continued support and trust in Pollogo Carpool!</p>
      <p>
        To provide you with a better green travel experience, Pollogo will
        undergo a major version upgrade starting at <span>16:00 today</span>.
        During the upgrade, services will be suspended for about
        <span>2 hours</span>. We sincerely apologize for the inconvenience and
        appreciate your understanding and support.
      </p>
    </div>

    <div class="hr"></div>

    <h2>Upgrade Highlights:</h2>
    <div>
      <p class="fw fz_18 mr_top">Public Transport Trip Matching</p>
      <p>
        In the old version, private car trips could not connect with public
        transport trips. With this upgrade, you only need to publish a public
        transport trip and pay the prepaid fare, and the system will
        intelligently match you with a suitable driver.
      </p>
      <p class="fw fz_18 mr_top">Support for Cryptocurrency Payments</p>
      <p>
        Passengers can now use cryptocurrencies to pay fares, making travel more
        convenient and flexible.
      </p>
      <p class="fw fz_18 mr_top">Order Reward Mechanism</p>
      <p>
        To thank both drivers and passengers for their contributions to green
        travel, we are introducing an order reward mechanism:
      </p>
      <ul>
        <li>
          Drivers, passengers, their referrers, and city partners can all
          receive token rewards from the platform;
        </li>
        <li>
          One trip, multiple beneficiaries, making carpooling more valuable.
        </li>
      </ul>
      <p class="fw fz_18 mr_top">Check-in Points Optimization</p>
      <p>
        After an order is confirmed, passengers can increase the driver’s
        check-in points.
      </p>
      <p>
        A driver’s total check-in points = points from their own published trips
        + points contributed by passengers’ trips.
      </p>
    </div>

    <div class="hr"></div>

    <h2>Pollogo Trip Rules:</h2>
    <p class="fw fz_18 mr_top">1. Driver Verification</p>
    <ul>
      <li>
        Drivers must bind their phone number and complete driver authentication
        before publishing a trip.
      </li>
    </ul>
    <p class="fw fz_18 mr_top">2. Passenger Verification</p>
    <ul>
      <li>Passengers must bind their phone number before publishing a trip.</li>
    </ul>
    <p class="fw fz_18 mr_top">3. Trip Publishing Time</p>
    <ul>
      <li>
        Trips can only be published for
        <span>2 hours after the current time;</span>
      </li>
      <li>
        Within <span>1 hour before or after</span> a scheduled trip time, no
        other trips are allowed (including ended, pending, or canceled trips).
      </li>
    </ul>
    <p class="fw fz_18 mr_top">4. Earliest Departure Time</p>
    <ul>
      <li>
        Trips can depart <span>no earlier than 30 minutes before</span> the
        scheduled time.
      </li>
    </ul>
    <p class="fw fz_18 mr_top">5. Trip Matching</p>
    <ul>
      <li>
        Trip matching will close
        <span>within 1 hour prior to the scheduled departure time.</span>
      </li>
    </ul>
    <p class="fw fz_18 mr_top">6. Prepayment</p>
    <ul>
      <li>
        Passengers must pay the prepaid fare to view available drivers and
        appear in the drivers’ carpool list;
      </li>
      <li>
        If no driver accepts, the prepayment will be refunded to the passenger’s
        wallet after the trip is canceled or ended.
      </li>
    </ul>
    <p class="fw fz_18 mr_top">7. Decline Function</p>
    <ul>
      <li>
        If the trip is not suitable (not on the way or time conflict), the
        invitee may decline;
      </li>
      <li>
        After declining, both sides return to their matching pages, but cannot
        match again;
      </li>
      <li>
        A maximum of <span>5 declines per day</span> is allowed. On the 5th
        decline, the system will automatically cancel the user’s trip.
      </li>
    </ul>
    <p class="fw fz_18 mr_top">8. Fare Payment</p>
    <ul>
      <li>
        After an invitation/order is confirmed, passengers must complete payment
        within <span>30 minutes;</span>
      </li>
      <li>If not paid on time, both parties return to the matching pool.</li>
    </ul>
    <p class="fw fz_18 mr_top">9. Trip Cancellation Rules</p>

    <p class="fw fz_18 mr_top">Driver cancellations:</p>
    <ul>
      <li>
        More than 30 minutes before departure: may cancel without penalty;
      </li>
      <li>
        Less than 30 minutes before departure: driver is restricted from posting
        trips for 3 days (including the current day); if all passengers agree to
        waive, no penalty applies;
      </li>
      <li>
        Within 30 minutes of departure: driver is restricted for 3 days
        (including the current day); if all passengers agree to waive, no
        penalty applies;
      </li>
      <li>
        More than 30 minutes after departure: driver is restricted for 7 days
        (including the current day); if all passengers agree to waive, no
        penalty applies.
      </li>
    </ul>
    <p class="fw fz_18 mr_top">Passenger cancellations:</p>
    <ul>
      <li>More than 30 minutes before departure: full refund;</li>
      <li>
        Less than 30 minutes before departure: 90% fare refunded (if driver
        waives, full refund);
      </li>
      <li>
        Within 30 minutes of departure: 70% fare refunded (if driver waives,
        full refund);
      </li>
      <li>
        After departure time: 50% fare refunded (if driver waives, full refund);
      </li>
      <li>
        After departure time and driver has not yet arrived at the pickup point:
        full refund.
      </li>
    </ul>
    <p class="fw">Other Notes:</p>
    <ul>
      <li>Once a passenger has boarded, the trip cannot be canceled;</li>
      <li>
        Active cancellations consume one trip quota for the day; passive
        cancellations do not;
      </li>
      <li>
        Passengers may choose to cancel only their ride or the entire trip.
      </li>
    </ul>
    <p class="fw">10. Lateness Rules</p>
    <ul>
      <li>
        <span>Driver lateness: </span>f the driver does not arrive at the pickup
        point within 15 minutes after the passenger’s departure time, and the
        passenger cancels, the driver will be restricted from publishing trips
        for 3 days (including the current day). If the passenger waives, no
        penalty applies.
      </li>
      <li>
        <span>Passenger lateness:</span>If the driver has arrived and waited
        more than 15 minutes, but the passenger has not boarded, the driver may
        cancel. The entire fare will be withheld as a penalty (gratitude fee
        refunded). If the driver waives, no penalty applies.
      </li>
    </ul>

    <p class="fw">11. Departure Timeout Cancellation</p>
    <ul>
      <li>
        For unmatched trips, if no departure occurs within 1 hour after the
        scheduled time, the system will automatically cancel the trip.
      </li>
    </ul>
    <p class="fw">12. Driver Departure Timeout Cancellation</p>
    <ul>
      <li>
        For matched trips, if the driver has not departed within 1 hour after
        the scheduled departure time, the system will cancel both the driver and
        passenger trips, and restrict the driver from publishing trips for 3
        days.
      </li>
    </ul>
    <p class="fw">13. Fare & CPLE Distribution</p>
    <ul class="level-1">
      <li>When a trip ends normally:</li>
      <ul class="level-2">
        <li>80% of the fare goes to the driver;</li>
        <li>4% goes to the platform as an operations fee;</li>
        <li>16% is used to automatically purchase platform tokens:</li>
        <ul class="lever-3" style="margin-left: 20px !important">
          <li>Driver and passenger each receive 4% equivalent in tokens;</li>
          <li>
            Driver referrer, passenger referrer, and city partner each receive
            1% equivalent in tokens;
          </li>
          <li>Remaining tokens are burned.</li>
        </ul>
      </ul>
    </ul>
    <p class="fw">14. Email Notifications</p>
    <p class="fw">Passenger notifications:</p>
    <ul>
      <li>Scenario 1: When a driver invites a passenger;</li>
      <li>Scenario 2: When the driver arrives at the pickup point;</li>
      <li>Scenario 3: When the driver arrives at the drop-off point;</li>
      <li>Scenario 4: When the trip ends.</li>
    </ul>
    <p class="fw">Driver notifications:</p>
    <ul>
      <li>Scenario 1: When a passenger invites the driver;</li>
      <li>Scenario 2: When the passenger completes payment;</li>
      <li>Scenario 3: When the trip ends.</li>
    </ul>

    <div class="hr"></div>

    <h2>Our Vision</h2>
    <p>
      With this upgrade, Pollogo is not just a carpooling app, but a
      <span>green travel + blockchain incentive platform.</span>
    </p>
    <p>
      We aim to attract more users to join the
      <span>green travel mining ecosystem</span>, making every trip a practice
      of low-carbon, shared, and mutually beneficial travel.
    </p>
    <p>
      Thank you for being with us along the way. We look forward to starting
      more green journeys with you in the new version of Pollogo!
    </p>
    <p>Pollogo Team</p>
    <a href="https://www.pollogo.world/" target="_blank">www.pollogo.world</a>

    <div class="hr"></div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { t, locale } = useI18n();
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
}

@media (min-width: 601px) {
  .notice {
    width: 60%;
    margin: 20px auto;

    h2 {
      margin-bottom: 10px;
    }

    p {
      text-align: justify;
      line-height: 35px;
      font-weight: normal;
    }

    .fw,
    span {
      font-weight: bold;
    }

    .fz_18 {
      font-size: 18px;
    }

    .mr_top {
      margin-top: 10px;
    }

    .hr {
      width: 100%;
      height: 1px;
      background: #ccc;
      margin: 20px 0;
    }

    ul {
      margin-top: 10px;
      margin-left: 24px;
    }

    li {
      margin-bottom: 10px;
      margin-left: 15px;
      font-weight: normal;
      line-height: 30px;
    }

    ul.level-1 {
      list-style-type: disc; /* 实心圆 ● */
      margin-left: 1em;
    }

    ul.level-2 {
      list-style-type: circle; /* 空心圆 ○ */
      margin-left: 1.5em;
    }

    ul.level-3 {
      list-style-type: square; /* 方块 ■ */
    }

    a {
      color: #00ceff;
    }
  }
}
</style>
